import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t-4 border-black">
      <div className="max-w-[1440px] mx-auto px-[60px] py-[50px]">
        <div className="flex flex-col gap-[50px]">
          {/* Main Footer Content */}
          <div className="flex justify-between h-[192px]">
            {/* Logo and Social Icons */}
            <div className="flex flex-col gap-4 w-[156.8px]">
              <Link to="/">
                <img 
                  src="/logo-wordmark.svg" 
                  alt="Wishful" 
                  className="h-8 w-auto"
                />
              </Link>
              <div className="flex gap-3">
                <a href="https://twitter.com/getwishful" className="text-[#364153] hover:text-[#780000] transition-colors">
                  <Twitter className="h-[30px] w-[30px]" />
                </a>
                <a href="https://instagram.com/getwishful" className="text-[#364153] hover:text-[#780000] transition-colors">
                  <Instagram className="h-[30px] w-[30px]" />
                </a>
                <a href="mailto:hello@getwishful.com" className="text-[#364153] hover:text-[#780000] transition-colors">
                  <Mail className="h-[30px] w-[30px]" />
                </a>
              </div>
            </div>

            {/* Product Column */}
            <div className="flex flex-col gap-4 w-[156.8px]">
              <h4 className="text-[30px] font-black leading-[35px] tracking-[-0.9px] text-[#780000]" style={{ fontFamily: 'Noto Sans, sans-serif', fontVariationSettings: "'CTGR' 100, 'wdth' 62.5" }}>
                Product
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/dashboard" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Wishlists
                </Link>
                <Link to="/secret-santa-generator" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Secret Santa
                </Link>
                <Link to="/price-tracker" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Price Tracker
                </Link>
              </div>
            </div>

            {/* Company Column */}
            <div className="flex flex-col gap-4 w-[156.8px]">
              <h4 className="text-[30px] font-black leading-[35px] tracking-[-0.9px] text-[#780000]" style={{ fontFamily: 'Noto Sans, sans-serif', fontVariationSettings: "'CTGR' 100, 'wdth' 62.5" }}>
                Company
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/about" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  About
                </Link>
                <Link to="/blog" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Blog
                </Link>
              </div>
            </div>

            {/* Legal Column */}
            <div className="flex flex-col gap-4 w-[156.8px]">
              <h4 className="text-[30px] font-black leading-[35px] tracking-[-0.9px] text-[#780000]" style={{ fontFamily: 'Noto Sans, sans-serif', fontVariationSettings: "'CTGR' 100, 'wdth' 62.5" }}>
                Legal
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/privacy" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Privacy
                </Link>
                <Link to="/terms" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Terms
                </Link>
                <Link to="/security" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Security
                </Link>
                <Link to="/cookies" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Cookies
                </Link>
              </div>
            </div>

            {/* Support Column */}
            <div className="flex flex-col gap-4 w-[156.8px]">
              <h4 className="text-[30px] font-black leading-[35px] tracking-[-0.9px] text-[#780000]" style={{ fontFamily: 'Noto Sans, sans-serif', fontVariationSettings: "'CTGR' 100, 'wdth' 62.5" }}>
                Support
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/contact" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Contact
                </Link>
                <Link to="/status" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Status
                </Link>
                <Link to="/feedback" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                  Feedback
                </Link>
              </div>
            </div>
          </div>

          {/* Bottom Row - Copyright and Links */}
          <div className="flex justify-between items-center h-[60px] border-t-2 border-[#d1d5dc] pt-[24px]">
            <p className="text-[#364153] text-base leading-[27.2px]" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
              © 2025 wishful. made with ❤️ for wishers everywhere
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-[#364153] text-base leading-6 hover:text-[#780000] transition-colors" style={{ fontFamily: 'Open Sans, sans-serif', fontVariationSettings: "'wdth' 100" }}>
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
